import * as React from "react";

;
export const AccountLimits = (props: React.SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}><path fill="#100722" d="M22.25 24h1.5V0h-1.5v24ZM12.75 7.2V24h-1.5V7.2h1.5ZM1.75 12v12H.25V12h1.5Z" /></svg>;